/**
 * Backend returns `AuthenticationFailed` with `access_token` when the password-update JWT
 * is expired, invalid, or revoked (BraincareAuthBackend and serializers).
 */
export function isPasswordUpdateAccessInvalid(apiErrorData) {
  const raw = apiErrorData?.access_token;
  const msg = Array.isArray(raw) ? raw[0] : raw;
  if (typeof msg !== 'string') return false;
  const normalized = msg.toLowerCase();
  return normalized.includes('expired access token') || normalized.includes('invalid access token');
}
